
import { defineComponent } from 'vue';
import UpdateDialog from '@/components/updates/UpdateDialog.vue';

export default defineComponent({
  props: {
    scope: { type: String, required: true },
    from: { type: String, required: false },
    till: { type: String, required: false },
    promotedTill: { type: String, required: false },
  },
  mounted() {
    if (this.scope && this.isPromoted) {
      const previouslyLoaded = localStorage.getItem(
        `updates-modal-${this.scope}`,
      );

      if (!previouslyLoaded) {
        this.openUpdateModal();
        localStorage.setItem(`updates-modal-${this.scope}`, 'true');
      }
    }
  },
  computed: {
    isActive(): boolean {
      const now = Date.now();
      const from = new Date(this.from ?? now).getTime();
      const till = new Date(this.till ?? now).getTime();

      return from <= now && now <= till;
    },
    isPromoted(): boolean {
      if (this.isActive && this.promotedTill) {
        const promoted = new Date(this.promotedTill);
        return new Date() < promoted;
      }
      return false;
    },
  },
  methods: {
    openUpdateModal() {
      this.$buefy.modal.open({
        parent: this.$parent as any,
        component: UpdateDialog as any,
        props: { scope: this.scope },
        hasModalCard: true,
        trapFocus: true,
      });
    },
  },
});
